import './PreferenceToggles.scss';
import { NotificationPreferences } from './NotificationPreferences';
import React from 'react';
import { SalesforcePreferences } from './SalesforcePreferences';

export const PreferenceToggles: React.FC = () =>
	<div className='preference-toggles'>
		<SalesforcePreferences />
		<NotificationPreferences />
	</div>;


